import { PageTab } from "marketplace/_views/profiles/profiles-page-tabs";

/**
 * The search parameter that says the person was sent to their profile to fill in their professional
 * credentials, and the value that says so. The form reads it to explain why it opened and to put the
 * cursor in the field, because the field sits below everything else on a long form.
 */
export const profilePromptSearchParameter = "prompt";
export const credentialsProfilePrompt = "credentials";

/**
 * Where a person edits their own individual profile.
 *
 * Straight into the editor when the session knows which individual is theirs, since everyone who
 * is sent here is sent to change something in it. Without the id, the profiles page, which lists the
 * one profile they have or offers to create it — a session can be a response behind the profile
 * the API made for it, and guessing "create" would offer them a second one.
 *
 * `promptForCredentials` is for the places that send someone here because a team will not take
 * them until their credentials are filled out (#5800): the dashboard queue and member onboarding.
 */
export function ownIndividualProfileRoute(
  individualId: string | undefined,
  options?: { promptForCredentials?: boolean },
): string {
  const profilesPage = `/marketplace/profiles/${PageTab.Individual}`;
  if (!individualId) return profilesPage;

  const editor = `${profilesPage}/edit/${individualId}`;
  if (!options?.promptForCredentials) return editor;
  return `${editor}?${new URLSearchParams({ [profilePromptSearchParameter]: credentialsProfilePrompt })}`;
}

/** Whether the profile editor was opened to ask for the person's professional credentials. */
export function isPromptingForCredentials(searchParams: URLSearchParams | undefined): boolean {
  return searchParams?.get(profilePromptSearchParameter) === credentialsProfilePrompt;
}
